export var DeliverySectionText;
(function (DeliverySectionText) {
    DeliverySectionText["GENERIC_ERROR"] = "Something went wrong. Please try again";
    DeliverySectionText["DEFAULT_TITLE"] = "Delivery Information";
    DeliverySectionText["CHANGE_DELIVERY_ADDRESS"] = "Change delivery address";
    DeliverySectionText["ADD_DELIVERY_ADDRESS"] = "Add delivery address";
    DeliverySectionText["CHANGE_LOCATION"] = "Change location";
    DeliverySectionText["INVALID_POSTAL_CODE"] = "Sorry, we do not provide service to this postal code!";
    DeliverySectionText["DELIVERY_SCHEDULE_WARNING_TITLE"] = "Different Delivery Schedule Warning";
    DeliverySectionText["DELIVERY_SCHEDULE_ADDRESS_WARNING"] = "This address has a different delivery schedule.";
    DeliverySectionText["DELIVERY_SCHEDULE_LOCATION_WARNING"] = "This location has a different delivery schedule.";
    DeliverySectionText["ADDRESS_SELECT_CONFIRM"] = "Select Confirm to choose this address and update your days and {meal_entity_name_plural}";
    DeliverySectionText["LOCATION_SELECT_CONFIRM"] = "Select Confirm to choose this location and update your days and {meal_entity_name_plural}";
    DeliverySectionText["ADDRESS_SELECT_CANCEL"] = "Select Cancel to choose a different address";
    DeliverySectionText["LOCATION_SELECT_CANCEL"] = "Select Cancel to choose a different location";
    DeliverySectionText["ADDRESS_UPDATE_SUCCESS"] = "Delivery address updated successfully";
    DeliverySectionText["LOCATION_UPDATE_SUCCESS"] = "Pick up location updated successfully";
    DeliverySectionText["CANCEL"] = "Cancel";
    DeliverySectionText["CONFIRM"] = "Confirm";
})(DeliverySectionText || (DeliverySectionText = {}));
